import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Card #628: a pay-as-you-go workspace's free first import asks before it is sent - "Your first
 * import is free. Make sure this file has every contact you want, the next file will be charged."
 * Cancel (or closing the window) sends nothing, so the user can still fix the file; only "Import"
 * answers true.
 */
@Component({
  selector: 'app-import-free-first-dialog',
  standalone: true,
  imports: [MatDialogModule, TranslateModule],
  templateUrl: './import-free-first-dialog.component.html',
})
export class ImportFreeFirstDialogComponent {
  constructor(public dialogRef: MatDialogRef<ImportFreeFirstDialogComponent, boolean>) {}

  answer(ok: boolean): void {
    this.dialogRef.close(ok);
  }
}
